module.exports = __webpack_public_path__ + "img/luna gibosa menguante.10f3381b.png";